import { render, staticRenderFns } from "./ShozokuAddDialog.vue?vue&type=template&id=00c98062"
import script from "./ShozokuAddDialog.vue?vue&type=script&lang=js"
export * from "./ShozokuAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports